module.exports = __webpack_public_path__ + "img/partner7.e67b9b8a.png";